import { FETCH_ROAMING_PARTNER_LIST } from "../../actions/actionTypes";

const initialState = {  
    data: [],
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {    
        case FETCH_ROAMING_PARTNER_LIST.REQUEST:
            return { ...state, loading: true };
        case FETCH_ROAMING_PARTNER_LIST.FAILURE:
            return { ...state, loading: false };
        case FETCH_ROAMING_PARTNER_LIST.SUCCESS:
            return { ...state, data: action.data, loading: false };
        default:
            return state;
    }
};

export default reducer;